// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  AddTaskOutlined,
  Contrast,
  DoNotDisturbAltOutlined,
  EditOutlined,
  InventoryOutlined,
  KeyboardTabOutlined,
  LocalShippingOutlined,
  PendingOutlined,
  SettingsEthernetOutlined,
} from '@/constants/hardfin-standard-icons';
import { ROPhase, ROSubstatus } from '@/return-order/constants/status';
import { ReactElement } from 'react';

/**
 * Icon components for each base status (phase).
 */
const RO_BASE_STATUS_ICONS: Record<ROPhase, () => ReactElement> = {
  draft: () => <EditOutlined fontSize="small" />,
  awaiting_3pl: () => <SettingsEthernetOutlined fontSize="small" />,
  open: () => <PendingOutlined fontSize="small" />,
  shipped: () => <LocalShippingOutlined fontSize="small" />,
  delivered: () => <KeyboardTabOutlined fontSize="small" />,
  received: () => <InventoryOutlined fontSize="small" />,
  cancelled: () => <DoNotDisturbAltOutlined fontSize="small" />,
};

/**
 * Get the appropriate icon for a status.
 * Partial and overage modifiers override the base icon.
 */
export function getStatusIcon(
  base: ROPhase,
  modifier: ROSubstatus | null
): ReactElement {
  if (modifier === 'partial') {
    return <Contrast fontSize="small" />;
  }
  if (modifier === 'overage') {
    return <AddTaskOutlined fontSize="small" />;
  }
  return RO_BASE_STATUS_ICONS[base]();
}
